module.exports = __webpack_public_path__ + "static/media/red-decrease-indicator.b744e0a6.svg";